import { CanDeactivateFn } from "@angular/router";
import { Observable } from "rxjs";

/** Pantalla que avisa antes de perder cambios sin guardar al salir de la ruta. */
export interface ConCambiosSinGuardar {
  /** true deja salir; false se queda en la pantalla. */
  confirmarSalida(): Observable<boolean> | boolean;
}

export const cambiosSinGuardarGuard: CanDeactivateFn<ConCambiosSinGuardar> = (
  pantalla: ConCambiosSinGuardar,
): Observable<boolean> | boolean => pantalla?.confirmarSalida?.() ?? true;
